import { render, staticRenderFns } from "./WorkspaceMachineForm.vue?vue&type=template&id=2df919af"
import script from "./WorkspaceMachineForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceMachineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports